export const formatAmount = (amount) => {
    if(amount === undefined || amount === null || amount === '') {
        return '-';
    }   
    return Number.isNaN(Number(amount.replaceAll(',', ''))) ? '-' : Number(amount.replaceAll(',', '')) / 1e18;
}